import React from 'react';
import IndustryPageTemplate from '@/components/IndustryPageTemplate';
import { solutionsAds } from '@/config/ads';

const Agencies: React.FC = () => {
  return (
    <IndustryPageTemplate
      slug="agencies"
      industry="Agencies"
      heroHeadline="Creating interactive ads helps agencies deliver stronger results, and more revenue for clients."
      heroSubheadline="Stand out from the competition with dynamic, engaging ad formats that capture attention and drive measurable outcomes."
      section2Title="Clients expect richer, more dynamic digital experiences—not static banners."
      section2Content="The bar for digital advertising has risen. Clients want creative that stands out in crowded feeds and delivers real engagement. Interactive formats give you the tools to exceed expectations without blowing budgets or timelines."
      section3Title="Interactive formats drive higher engagement and improve campaign performance."
      section3Content="When users can interact with creative—exploring products, watching videos, or engaging with content—they pay more attention and take more action. That translates to better metrics and happier clients."
      section4Title="Ideal for creative, strategy, and media teams aiming to differentiate and scale production without added overhead."
      section4Content="Adventive empowers your team to produce premium interactive creative in-house, without specialized developers or extended timelines."
      heroImage="https://d64gsuwffb70l.cloudfront.net/69408eb499b5789ef7367cf9_1765838649966_0eb2b025.png"
      heroAd={solutionsAds.agency1}
      section2Ad={solutionsAds.agency2}
      section3Ad={solutionsAds.agency3}
      accentColor="bg-purple-100 text-purple-700"
      stats={[
        { value: '10x', label: 'Faster production' },
        { value: '+62%', label: 'Client satisfaction' },
        { value: '3x', label: 'Campaign performance' },
        { value: '50+', label: 'Templates available' },
      ]}
      benefits={[
        'Creative teams building campaigns',
        'Strategy teams planning media',
        'Account teams managing clients',
        'Production teams scaling output',
      ]}
    />
  );
};

export default Agencies;
